import React from 'react'
import PropTypes from 'prop-types'
import EventCardSmallContainer from './EventCardSmallContainer'
import EventCardEmptyContent from './EventCardEmptyContent'

const EventCardSmallEmpty = ({
  tag,
  image,
  showJoinButton,
  showComingSoonButton,
  onJoinButtonClick,
}) => (
  <EventCardSmallContainer
    className="bg-cover bg-center"
    style={{ backgroundImage: `url(${image})` }}
  >
    <EventCardEmptyContent
      tag={tag}
      showJoinButton={showJoinButton}
      showComingSoonButton={showComingSoonButton}
      onJoinButtonClick={onJoinButtonClick}
    />
  </EventCardSmallContainer>
)

EventCardSmallEmpty.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  image: PropTypes.string.isRequired,
  showJoinButton: PropTypes.bool,
  showComingSoonButton: PropTypes.bool,
  onJoinButtonClick: PropTypes.func,
}

EventCardSmallEmpty.defaultProps = {
  showJoinButton: false,
  showComingSoonButton: false,
}

export default EventCardSmallEmpty
